import { combineReducers } from 'redux';
import headerReducer from './headerReducer';
import loadingSpinnerReducer from './loadingSpinnerReducer';
import sidebarReducer from './sidebarReducer';
export default combineReducers({
    loadingSpinnerReducer: loadingSpinnerReducer,
    sidebarReducer: sidebarReducer,
    headerReducer: headerReducer
});



//////////////////
// WEBPACK FOOTER
// ./src/reducers/baseReducer.ts
// module id = 630
// module chunks = 0